import { FC } from 'react'
import Layout from 'components/layout/Layout'
import RegistrationLoading from 'features/registration-loading/RegistrationLoading'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'

const ExpressRegistrationPage: FC = (props) => {
  return (
    <Layout hideHeader>
      <RegistrationLoading {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'registration'], i18nConfig))
    }
  }
}

export default ExpressRegistrationPage
